import { decamelize } from 'humps';

import {
  MessagePayload,
  ThreadPayload,
  MutationParams,
} from '../types/SecureMessageThreads';

import { baseApi } from './baseApi';

const secureMessageApi = baseApi
  .enhanceEndpoints({ addTagTypes: ['Threads', 'Thread'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getSecureMessageThreads: builder.query<ThreadPayload[], void>({
        query: () => 'api/v6/secure_message_threads',
        providesTags: ['Threads'],
      }),
      getSecureMessageThread: builder.query<MessagePayload[], { id: number }>({
        query: ({ id }) => `api/v6/secure_message_threads/${id}`,
        providesTags: (_result, _error, { id }) => ([{ type: 'Thread', id }]),
      }),
      addSecureMessageThread: builder.mutation<ThreadPayload, MutationParams>({
        query: (params) => {
          const formData = new FormData();

          for (const key in params) {
            const value = params[key as keyof MutationParams];
            if (value) {
              formData.append(decamelize(key), value);
            }
          }

          return {
            url: 'api/v6/secure_message_threads',
            method: 'POST',
            body: formData,
          };
        },
      }),
      updateSecureMessageThread: builder.mutation<{ success: boolean }, MutationParams>({
        query: (params) => {
          const formData = new FormData();

          for (const key in params) {
            const value = params[key as keyof MutationParams];
            if (value) {
              formData.append(decamelize(key), value);
            }
          }

          return {
            url: 'api/v6/secure_messages',
            method: 'POST',
            body: formData,
          };
        },
        invalidatesTags: ['Threads'],
      }),
      readSecureMessageThread: builder.mutation<{ success: boolean }, number>({
        query: (id) => {
          return {
            url: 'api/v6/secure_messages/read',
            method: 'POST',
            body: { secure_message_thread_id: id },
          };
        },
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSecureMessageThreadsQuery,
  useGetSecureMessageThreadQuery,
  useAddSecureMessageThreadMutation,
  useUpdateSecureMessageThreadMutation,
  useReadSecureMessageThreadMutation,
} = secureMessageApi;
